import React from "react";
import { Link } from "react-router-dom";
import PolicyPage, { PolicyEmail } from "./PolicyPage";

const groups = [
  {
    title: "Privacy & communications",
    links: [
      ["Privacy Policy", "/privacy"],
      ["Your Privacy Choices", "/privacy-choices"],
      ["Cookie Policy", "/cookies"],
      ["Marketing Communications", "/marketing"],
    ],
  },
  {
    title: "Orders & payments",
    links: [
      ["Terms of Service", "/terms"],
      ["Payment & Billing", "/payments"],
      ["Order & Cancellation", "/orders"],
      ["Pricing, Promotions & Discounts", "/pricing-promotions"],
      ["Gift Cards", "/gift-cards"],
      ["Subscriptions & Recurring Purchases", "/subscriptions"],
    ],
  },
  {
    title: "Delivery & products",
    links: [
      ["Shipping Policy", "/shipping"],
      ["Returns & Refunds", "/returns"],
      ["Product Information & Food Safety", "/product-safety"],
      ["Warranty Policy", "/warranty"],
      ["Website & Product Disclaimer", "/disclaimer"],
    ],
  },
  {
    title: "Site standards & support",
    links: [
      ["Accessibility Statement", "/accessibility"],
      ["Acceptable Use", "/acceptable-use"],
      ["Reviews & User Content", "/reviews"],
      ["Security & Fraud Prevention", "/security-fraud"],
      ["Intellectual Property", "/intellectual-property"],
      ["Complaints & Dispute Resolution", "/complaints"],
    ],
  },
];

function PolicyCenter() {
  return (
    <PolicyPage
      title="Policy Center"
      intro={(
        <>
          <p>
            This page brings together the policies that apply to shopping with
            tugglefield. Select a topic below to review the applicable terms,
            choices, and customer protections.
          </p>
          <p>
            For help finding the right policy, email <PolicyEmail />.
          </p>
        </>
      )}
    >
      <div className="policy-index" aria-label="Policy directory">
        {groups.map((group) => (
          <section className="policy-index__group" key={group.title}>
            <h2>{group.title}</h2>
            <ul>
              {group.links.map(([label, path]) => (
                <li key={path}>
                  <Link to={path}>{label}</Link>
                </li>
              ))}
            </ul>
          </section>
        ))}
      </div>
    </PolicyPage>
  );
}

export default PolicyCenter;
